import { Fetch } from 'lib/Fetch';

export function findCiiu() {
  return new Fetch()
    .url('/portal/ciiu')
    .method('get')
    .portalToken()
    .send();
}
